import { Pane } from 'evergreen-ui';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { getTrackBackground, Range } from 'react-range';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';
import { updateSettings } from '../../../queries/settings';
import { setSettings } from '../../../store/settingsSlice';

const StyledSelector = styled.div`
  padding: 15px 25px;
  display: flex;
  flex-direction: column;

  .selectorContainer {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    background: #2b2d2e;
    font-size: 16px;
    padding: 30px 30px 20px;

    .timeContainer {
      display: flex;
      color: #e9ebed;
      justify-content: space-between;
      align-items: center;

      p {
        margin: 0 0 20px;
      }
    }
  }

  .tip {
    display: block;
    color: #a7aaac;
    font-size: 13px;
    margin: 45px 0 15px;

    & > span {
      color: #e78850;
      margin: 0 0.25em;
    }
  }
`;

const MIN = 0;
const MAX = 60;

const PanelExtraTime = ({ settings, enabled }) => {
  const dispatch = useDispatch();
  const { bufferTime, dayFilters } = settings;
  const token = useSelector(state => state.authentication.token);
  const updateSettingsQuery = useMutation(updateSettings, {
    useErrorBoundary: true,
  });

  const [buffer, setBuffer] = useState([bufferTime ?? 0]);

  useEffect(() => {
    setBuffer([bufferTime ?? 0]);
  }, [bufferTime]);

  const updateBuffer = values => {
    setBuffer(values);
  };
  const setNewBuffer = useCallback(
    async values => {
      await updateSettingsQuery.mutateAsync({
        bufferTime: values[0],
        dayFilters,
        enabled,
        token,
      });
      dispatch(setSettings({ ...settings, bufferTime: values[0] }));
    },
    [dayFilters, dispatch, enabled, settings, token, updateSettingsQuery],
  );

  return (
    <Pane
      background="#1F2021"
      position="relative"
      display="flex"
      flex={1}
      height="100%"
      flexDirection="column"
      paddingBottom={30}
    >
      <StyledSelector>
        <h2 style={{ color: 'white', fontSize: 18, marginBottom: 0 }}>Add extra time to arrrive</h2>
        <p style={{ color: '#A7AAAC' }}>
          Set a buffer time to make sure shifts are not accepted with too little time so you don’t miss the start time.
        </p>
        <div className="selectorContainer">
          <div className="timeContainer">
            <p>Buffer time</p>
            <p>{buffer}</p>
          </div>
          <Range
            draggableTrack
            values={buffer}
            step={15}
            min={MIN}
            max={MAX}
            onChange={updateBuffer}
            onFinalChange={setNewBuffer}
            renderTrack={({ props, children }) => (
              <div
                onMouseDown={props.onMouseDown}
                onTouchStart={props.onTouchStart}
                style={{
                  ...props.style,
                  height: '36px',
                  display: 'flex',
                  width: '100%',
                }}
              >
                <div
                  ref={props.ref}
                  style={{
                    height: '5px',
                    width: '100%',
                    borderRadius: '4px',
                    background: getTrackBackground({
                      values: buffer,
                      colors: ['#E78850', '#3E4143'],
                      min: MIN,
                      max: MAX,
                    }),
                    alignSelf: 'center',
                  }}
                >
                  {children}
                </div>
              </div>
            )}
            renderThumb={({ props, isDragged }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '28px',
                  width: '28px',
                  backgroundColor: '#FFFFFF',
                  borderRadius: 28,
                  outline: 'none',
                }}
              />
            )}
          />
        </div>
        <div className="tip">
          If an shift appears that starts in less than <span>{buffer[0]} Minutes</span> from now it will be rejected
        </div>
      </StyledSelector>
    </Pane>
  );
};

export default PanelExtraTime;
